import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useState, useEffect } from 'react';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';
import { FileLink, show, fmtDate, EmpStatus } from './regUtils';

export const CAND_ROWS = [
  ['Mobile', 'mobile'], ['WhatsApp', 'whatsapp'], ['Email', 'email'], ['Age', 'age'], ['Gender', 'gender'],
  ['State', 'state'], ['District', 'district'], ['City', 'city'], ['Highest Qualification', 'highest_qualification'],
  ['Course', 'course'], ['Department', 'department'], ['College', 'college'], ['Year of Passing', 'year_of_passing'],
  ['Fresher / Experienced', 'experience_type'], ['Total Experience', 'total_experience'], ['Skills', 'skills'], ['Languages', 'languages'],
];
export const EMP_ROWS = [
  ['Industry', 'industry'], ['Industry (Other)', 'industry_other'], ['Website', 'website'], ['State', 'company_state'],
  ['City', 'company_city'], ['Address', 'company_address'], ['HR Name', 'hr_name'], ['Designation', 'hr_designation'],
  ['Email', 'hr_email'], ['Mobile', 'hr_mobile'], ['Total Vacancies', 'total_vacancies'], ['Job Roles', 'job_roles'],
  ['Required Qualification', 'required_qualification'], ['Experience Required', 'experience_required'],
  ['Job Locations', 'job_locations'], ['Salary / CTC', 'salary'], ['Work Mode', 'work_mode'], ['Shift', 'shift'],
  ['Participation', 'participation'], ['Team Members', 'team_members'], ['Interview Types', 'interview_types'], ['Interview (Other)', 'interview_other'],
];

const StatusActions = ({ rec, onStatus }) => {
  const [notes, setNotes] = useState(rec.status_notes || '');
  useEffect(() => setNotes(rec.status_notes || ''), [rec]);
  return (
    <div className="rounded-lg border p-3 space-y-2 bg-slate-50">
      <p className="text-sm font-semibold">Verification</p>
      <Textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes (optional)" data-testid="profile-status-notes" />
      <div className="flex flex-wrap gap-2">
        <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => onStatus(rec, 'approved', notes)} data-testid="profile-approve-button"><CheckCircle2 className="w-4 h-4 mr-1" />Approve</Button>
        <Button size="sm" variant="outline" className="text-red-600 border-red-200" onClick={() => onStatus(rec, 'rejected', notes)} data-testid="profile-reject-button"><XCircle className="w-4 h-4 mr-1" />Reject</Button>
        <Button size="sm" variant="ghost" onClick={() => onStatus(rec, 'under_verification', notes)} data-testid="profile-pending-button"><Clock className="w-4 h-4 mr-1" />Under Verification</Button>
      </div>
    </div>
  );
};

export const ProfileSheet = ({ fairId, rec, kind, onClose, onStatus }) => {
  const isEmp = kind === 'employer';
  const files = rec?.files || {};
  const photo = isEmp ? files.company_logo : files.photo;
  return (
    <Sheet open={!!rec} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto" data-testid="registration-profile-sheet">
        {rec && (
          <>
            <SheetHeader>
              <div className="flex items-center gap-4">
                {photo?.url ? <img src={photo.url} alt="" className="w-16 h-16 rounded-xl object-cover border" /> : <div className="w-16 h-16 rounded-xl bg-teal-50 text-teal-700 flex items-center justify-center text-2xl font-bold">{(rec.full_name || rec.company_name || '?')[0]}</div>}
                <div className="text-left">
                  <SheetTitle data-testid="profile-name">{isEmp ? rec.company_name : rec.full_name}</SheetTitle>
                  <p className="font-mono text-sm text-teal-700" data-testid="profile-reg-id">{rec.registration_id}</p>
                  {isEmp && <EmpStatus s={rec.status} testId="profile-employer-status" />}
                </div>
              </div>
            </SheetHeader>
            <div className="mt-6 space-y-4">
              {isEmp && <StatusActions rec={rec} onStatus={onStatus} />}
              <div className="flex flex-wrap gap-4 rounded-lg border p-3">
                {(isEmp ? [['id_proof', 'ID_Proof'], ['company_logo', 'Logo']] : [['resume', 'Resume'], ['photo', 'Photo']]).map(([k, l]) => (
                  <div key={k} className="text-sm"><p className="text-xs text-slate-500">{l.replace('_', ' ')}</p><FileLink fairId={fairId} file={files[k]} label={`${rec.registration_id}_${l}`} testId={`profile-download-${k}`} /></div>
                ))}
              </div>
              <dl className="divide-y border rounded-lg">
                {(isEmp ? EMP_ROWS : CAND_ROWS).map(([l, k]) => (
                  <div key={k} className="grid grid-cols-[10rem_1fr] gap-3 px-3 py-2 text-sm"><dt className="text-slate-500">{l}</dt><dd className="text-slate-900 break-words">{show(rec[k])}</dd></div>
                ))}
                <div className="grid grid-cols-[10rem_1fr] gap-3 px-3 py-2 text-sm"><dt className="text-slate-500">Registered</dt><dd>{fmtDate(rec.created_at)}</dd></div>
              </dl>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
